export default {
    search: 'Find carriers',
    accessToEndOfDay: 'Search by directions within the Russian Federation until the end of the day',
    accessTo: 'Access will be valid until',
    currency: 'rubles',
    remaining: 'Will be valid until 11:59 p.m. ({{hours}} more h. and {{minutes}} m.)',
    free: 'Free',
    outsideRussia: 'outside of Russia',
};
